module.exports = __webpack_public_path__ + "media/images/netero-5448b9dbd89212d886642b737d442ff9.svg";